import { ReactNode } from 'react';

import { DialogControlledProps, DialogStaticProps } from '../DialogComposite';
import { DialogCompositeMui as DialogComposite } from '../DialogCompositeMui';

export type RootProps = (
  | Omit<DialogControlledProps, 'children' | 'ref'>
  | Omit<DialogStaticProps, 'children' | 'ref'>
) & {
  children: ReactNode;
};

const Root = (props: RootProps) => {
  return <DialogComposite.Root {...props} />;
};

export default Root;
